import React from 'react'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import LoadingIcon from '../../atoms/LoadingIcon'

const Content = styled(View)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
`

const LoadingWrapper = styled(View)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

const LoadingBackdrop = () => (
  <Content>
    <LoadingWrapper>
      <LoadingIcon src="https://static.olx.com.br/accounts/loading.gif" />
    </LoadingWrapper>
  </Content>
)

export default LoadingBackdrop
